const tabs = {
    actions: 'Actions',
    get_started: 'Primeiros passos',
    dashboard: 'Painel',
    applications: 'Aplicativos',
    api_resources: 'Recursos da API',
    sign_in_experience: 'Login e conta',
    connectors: 'Conectores',
    enterprise_sso: 'SSO Empresarial',
    security: 'Segurança',
    webhooks: 'Webhooks',
    organizations: 'Organizações',
    users: 'Usuários',
    audit_logs: 'Logs de auditoria',
    roles: 'Funções',
    docs: 'Documentação',
    tenant_settings: 'Configurações do inquilino',
    mfa: 'Autenticação multifator',
    customize_jwt: 'Personalizar JWT',
    signing_keys: 'Chaves de assinatura',
    organization_template: 'Modelo de organização',
};
export default Object.freeze(tabs);
